import { client, gql } from 'data-provider';
import { EStatus } from 'enums';
import { CreateSaleData } from './sale';

export enum EOrderType {
  'DineIn' = 'DineIn',
  'Takeaway' = 'Takeaway',
}

export const STATUS_MAPPING = {
  [EStatus.CONFIRMED]: 'New',
  [EStatus.IN_PROGRESS]: 'Processing',
  [EStatus.COMPLETED]: 'Completed',
} as const;

export type CreateRestaurantPosPayload = Omit<CreateSaleData, 'salesExpense'> & {
  orderType: EOrderType;
  salesProducts: {
    sku: string;
    quantity: number;
    unitPrice: number;
    salesProductStatus: EStatus;
  }[];
};

export const createRestaurantPos = async (data: CreateRestaurantPosPayload) => {
  const mutation = gql`
    mutation ($input: createRestaurantPosSalesInput!) {
      createRestaurantPos(input: $input) {
        id
      }
    }
  `;

  const variables = {
    input: { data },
  };

  const createdData = await client.request(mutation, variables);
  return createdData.createRestaurantPos as { id: string };
};
